export default "__VITE_ASSET__Gt4u1Q5I__"